const en = {
  title: 'Historical Analytics',
  hint: 'Compare the selected rolling period with the immediately preceding period of equal length, using currently accessible tests.',
  executions: 'Completed executions',
  success: 'Success rate',
  failures: 'Failed executions',
  previous: 'Previous period',
  change: 'Change',
  daily: 'Daily execution results',
  utc: 'Daily buckets use UTC. The first and last days may be partial; totals match the selected rolling period. Days without runs have no success rate.',
  chartLabel:
    'Passed and failed executions by UTC date. Exact values are available in the daily data table below.',
  passed: 'Passed',
  failed: 'Failed',
  dailyTable: 'View daily data',
  date: 'Date (UTC)',
  projects: 'Project trends',
  previousRate: 'Previous success rate',
  rateChange: 'Change (pp)',
  projectHint:
    'Only projects with completed runs in either period are shown. Click a project to filter. pp = percentage points.',
  noHistory: 'No completed execution history in either period.',
  mixed: 'Tests with mixed outcomes',
  mixedHint:
    'Top 8 tests with both passed and failed runs in the selected period. Investigate their history: this can reflect a fix, changing data, or instability; it does not prove flakiness.',
  noMixed: 'No tests with both passed and failed results in this period.',
};
const es = {
  title: 'Analítica histórica',
  hint: 'Compara el período móvil seleccionado con el período anterior de igual duración, usando las pruebas accesibles actualmente.',
  executions: 'Ejecuciones completadas',
  success: 'Tasa de éxito',
  failures: 'Ejecuciones fallidas',
  previous: 'Período anterior',
  change: 'Cambio',
  daily: 'Resultados diarios de ejecución',
  utc: 'Los días usan UTC. El primero y el último pueden ser parciales; los totales corresponden al período móvil seleccionado. Los días sin ejecuciones no tienen tasa de éxito.',
  chartLabel:
    'Ejecuciones aprobadas y fallidas por fecha UTC. Los valores exactos están en la tabla diaria de abajo.',
  passed: 'Aprobadas',
  failed: 'Fallidas',
  dailyTable: 'Ver datos diarios',
  date: 'Fecha (UTC)',
  projects: 'Tendencias por proyecto',
  previousRate: 'Tasa de éxito anterior',
  rateChange: 'Cambio (pp)',
  projectHint:
    'Solo se muestran proyectos con ejecuciones completadas en alguno de los dos períodos. Pulsa un proyecto para filtrar. pp = puntos porcentuales.',
  noHistory: 'Sin ejecuciones completadas en ninguno de los períodos.',
  mixed: 'Pruebas con resultados mixtos',
  mixedHint:
    'Hasta 8 pruebas con ejecuciones aprobadas y fallidas en el período seleccionado. Revisa su historial: puede deberse a una corrección, datos cambiantes o inestabilidad; no demuestra por sí solo que la prueba sea inestable.',
  noMixed: 'No hay pruebas con resultados aprobados y fallidos en este período.',
};
export const historyCopy = (language) => (language === 'es' ? es : en);
